import {Observable, Subject} from 'rxjs';
import {Injectable, OnDestroy} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {System} from '../../../shared-components/System';
import {Category} from './models/category.model';
import {YearService} from '../../../shared-components/year/year.service';
import {AutoUnsubscribe} from 'ngx-auto-unsubscribe';
import {GradebookIndicator} from './models/gradebook-indicator.model';

@AutoUnsubscribe()
@Injectable()
export class SharedGradebookService implements OnDestroy {

    constructor(
        private http: HttpClient,
        private yearService: YearService
    ) {
    }

    saveCategories(courseId: number, termId: number, categories: Category[]) {
        return this.http.post<number>(System.apiURL.Classroom + 'SaveCategory?yearId=' + this.yearService.defaultYear.Id + '&courseId=' + courseId + '&termId=' + termId, categories);
    }

    deleteAttachment(attachmentId: number) {
        return this.http.get(System.apiURL.Classroom + 'DeleteGradebookAttachments?DocumentId=' + attachmentId);
    }

    clearLMSToken(lmsName: string) {
        return this.http.get(System.apiURL.Classroom + 'ClearLMSToken?lmsName=' + lmsName);
    }

    getLMSIntegrationLog(sectionId: number, lmsName: string): Observable<any> {
        return this.http.get(System.apiURL.Classroom + `GetLMSIntegrationLog?sectionId=${sectionId}&lmsName=${lmsName}`, { observe: 'response' });
    }

    getGradebookIndicators(courseId: number, termId: number): Observable<GradebookIndicator[]> {
        return this.http.get<GradebookIndicator[]>(System.apiURL.Classroom + `GetGradebookIndicators?courseId=${courseId}&termId=${termId}`);
    }

    saveGradebookIndicator(gradebookIndicators: GradebookIndicator, courseId: number): Observable<boolean> {
        return this.http.post<boolean>(System.apiURL.Classroom + `SaveGradebookIndicator?siteSectionId=${courseId}`, gradebookIndicators);
    }

    deleteGradebookIndicator(id: number): Observable<boolean> {
        return this.http.get<boolean>(System.apiURL.Classroom + `DeleteGradebookIndicator?Id=${id}`);
    }

    setCommentSmartTags(student, comment: string) {
        comment = comment.replace(/<name>/g, student.FirstName.substring(0, 1).toLowerCase() + student.FirstName.substring(1));
        comment = comment.replace(/<Name>/g, student.FirstName.substring(0, 1).toUpperCase() + student.FirstName.substring(1));
        comment = comment.replace(/<nickname>/gi, student.NickName);
        comment = comment.replace(/<gradelevel>/gi, student.GradeLevel);
        comment = comment.replace(/<studentnumber>/gi, student.StudentNumber);
        comment = comment.replace(/<schoolname>/gi, student.SchoolName);
        comment = comment.replace(/<he>|<she>|<his>|<her>|<him>|<himself>|<herself>/gi, function x(text) {
            if (student.Gender && (student.Gender.toLowerCase() == 'f' || student.Gender.toLowerCase() == 'female')) {
                if (text.toLowerCase() == '<he>') {
                    if (text.substring(0, 2) == '<H') {
                        text = 'She';
                    } else {
                        text = 'she';
                    }
                }

                if (text.toLowerCase() == '<his>') {
                    if (text.substring(0, 2) == '<H') {
                        text = 'Her';
                    } else {
                        text = 'her';
                    }
                }

                if (text.toLowerCase() == '<him>') {
                    if (text.substring(0, 2) == '<H') {
                        text = 'Her';
                    } else {
                        text = 'her';
                    }
                }

                if (text.toLowerCase() == '<himself>') {
                    if (text.substring(0, 2) == '<H') {
                        text = 'Herself';
                    } else {
                        text = 'herself';
                    }
                }

            } else if (student.Gender && (student.Gender.toLowerCase() == 'm' || student.Gender.toLowerCase() == 'male')) {
                if (text.toLowerCase() == '<he>') {
                    if (text.substring(0, 2) == '<H') {
                        text = 'He';
                    } else {
                        text = 'he';
                    }
                }

                if (text.toLowerCase() == '<his>') {
                    if (text.substring(0, 2) == '<H') {
                        text = 'His';
                    } else {
                        text = 'his';
                    }
                }

                if (text.toLowerCase() == '<him>') {
                    if (text.substring(0, 2) == '<H') {
                        text = 'Him';
                    } else {
                        text = 'him';
                    }
                }

                if (text.toLowerCase() == '<himself>') {
                    if (text.substring(0, 2) == '<H') {
                        text = 'Himself';
                    } else {
                        text = 'himself';
                    }
                }

            } else if (student.Gender && student.Gender.toLowerCase() != 'm' && student.Gender.toLowerCase() != 'male' && student.Gender.toLowerCase() != 'f' && student.Gender.toLowerCase() != 'female') {
                if (text.toLowerCase() == '<himself>' || text.toLowerCase() == '<herself>') {
                    text = (text.substring(0, 2) == '<H') ? 'Themself' : 'themself';
                } else if (text.toLowerCase() == '<him>' || text.toLowerCase() == 'her') {
                    text = (text.substring(0, 2) == '<H') ? 'Them' : 'them';
                } else if (text.toLowerCase() == '<his>') {
                    text = (text.substring(0, 2) == '<H') ? 'Their' : 'their';
                } else {
                    text = 'they';
                }
            }
            return text;
        });
        return comment;
    }

    ngOnDestroy() {
    }

}
